<template>
  <div style="padding-top:100px;">
    <button @click="toggleShow">
      <span >coin earned!</span>
    </button>
    <transition
      name="ballmove">
      <div v-if="isShowing">
        <app-child class="child"></app-child>
      </div>
    </transition>
    <script type="text/x-template" id="childarea">
      <div class="ball"></div>
    </script>
  </div>
</template>

<script>
const Child = {
  template: '#childarea'
}

export default {
  name: 'CoinEarned',
  data () {
    return {
      isShowing: false
    }
  },
  components: {
    appChild: Child
  },
  created: function () {
  },

  computed: {
  },
  watch: {
  },
  methods: {
    toggleShow () {
      this.isShowing = true
      let that = this
      setTimeout(function () {
        that.isShowing = false
      }, 2300)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  @mixin ballb($yaxis: 0) {
    transform: translate3d(0, $yaxis, 0);
  }

  .ball {
    width: 60px;
    height: 60px;
    background: url("http://devsfh.cogneti.com/static/img/coin.svg");
    transform-origin: 50% 50%;
    transform: translate3d(0, -1000px, 0) rotate(0);
    z-index: 9999!important;
  }

  @keyframes rollout {
    0% { transform: translate3d(0, 300px, 100px) rotateY(0);}
    50% { transform: translate3d(-10, 100px, 100px) rotateY(0);}
    100% { transform: translate3d(0, 0px, 0) rotateY(0);opacity: 0;
    }
  }

  @keyframes ballroll {
    0% { transform: rotateY(0); }
    100% { transform: rotateY(1000deg)}
  }

  .ballmove-enter {
    bottom: 0;
    position: fixed;
    @include ballb(600px);
  }

  .ballmove-enter-active, .ballmove-leave-active  {
    z-index: 9999!important;
    width: 60px;
    height: 60px;
    animation: ballroll 2s cubic-bezier(0.55, 0.085, 0.68, 0.53) both;
  }
  .ballmove-enter div {
    z-index: 9999!important;
    animation: rollout 3s cubic-bezier(0.55, 0.085, 0.68, 0.53) both;
  }
  .ballmove-leave-to div {
    z-index: 9999!important;
    animation: rollout 2s cubic-bezier(0.55, 0.085, 0.68, 0.53) both;
  }
</style>



// WEBPACK FOOTER //
// src/components/views/CoinEarned.vue